import { render, staticRenderFns } from "./share_details.vue?vue&type=template&id=384d2f9d&"
import script from "./share_details.vue?vue&type=script&lang=js&"
export * from "./share_details.vue?vue&type=script&lang=js&"
import style0 from "./share_details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports